import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withApi, extractData } from './ApiProvider'
import AppStateContext from '../contexts/AppStateContext'
import { BeRecipientApiContext } from '../contexts/BeRecipientApiContext'
import { ID_LIST_STORE_KEY } from '../helpers/Constants'
import { encodeParams } from '../helpers/encodeParams'


export const withBeRecipientApi = ComponentToWrap => {
  const WrappedComponent = (props) => {
    return (
      <BeRecipientApiContext.Consumer>
        {value => (
          <ComponentToWrap {...props} beRecipientApi={value} />
        )}
      </BeRecipientApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withBeRecipientApi(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const endpointsProvider = (baseURL) => {
  return {
    //  Groups
    getAllGroups: (idList, searchBy, pageSize, pageNumber, orderBy, orderDescending) => {
      const params = { searchBy, pageSize, pageNumber, orderBy, orderDescending }
      return `${baseURL}/api/list/${idList}/groups?${encodeParams(params)}`
    },
    //  Anagraphic fields
    getAnagraphicFields: `${baseURL}/api/fields`
  }
}

const BeRecipientApiProviderComponent = (props) => {
  const { children, apiWrapper } = props

  const { storeGet } = useContext(AppStateContext)

  const endpoints = endpointsProvider(process.env.BERECIPIENT_URL)

  const getAllGroups = (searchBy, pageSize, pageNumber, orderBy, orderDescending) => {
    const idList = storeGet(ID_LIST_STORE_KEY)
    const url = endpoints.getAllGroups(idList, searchBy, pageSize, pageNumber, orderBy, orderDescending)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getAnagraphicFields = () => {
    const url = endpoints.getAnagraphicFields

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const beRecipientApi = {
    getAllGroups,
    getAnagraphicFields
  }

  return (
    <BeRecipientApiContext.Provider value={beRecipientApi}>
      {children}
    </BeRecipientApiContext.Provider>
  )
}

BeRecipientApiProviderComponent.defaultProps = {
  children: null
}

BeRecipientApiProviderComponent.propTypes = {
  children: PropTypes.node,
  apiWrapper: PropTypes.func.isRequired
}

export const BeRecipientApiProvider = withApi(BeRecipientApiProviderComponent)
